module.exports = __webpack_public_path__ + "img/z.a515143d.svg";